import React from 'react';
import { Box, Link } from '@mui/joy';
import { useTranslation } from 'react-i18next';

const CellUrlButton = ({ value, field, type = 'simple' }) => {
    const { t } = useTranslation();
    return (
        <Box className={"list-element-cell cell-" + type}>
            {value && (
                <Link variant='soft' target='_blank' href={value} rel="noreferrer" color='primary'>{field.label || value}</Link>
                // <a href={value} rel="noreferrer" target='_blank'>{field.label || value}</a>
                )}
        </Box>
    )
}

export default CellUrlButton